// Üyelik kilidi (sunucu "engelle" modunda): süresi + 7 gün ek süresi dolmuş üyenin API isteklerine sunucu
// 403 + { m: "uyelik_suresi_doldu" } döner. Sayfalar bu yanıtı genel bir hata gibi gösteriyordu ("bilgiler yüklenirken
// hata oluştu"); üye neden kullanamadığını anlamıyordu. Tüm sayfalar fetch kullandığından tek noktada yakalanır ve üye
// /yenile sayfasına gönderilir (orada web oturumuyla doğrudan kendi üyelik bilgisini ve ödeme adımını görür).
// Döngü olmaz: /yenile sayfasındayken yönlendirilmez; /yenile'nin kullandığı /api/yenile/ ve /api/posnet/ uçları kilitten muaftır.
// Yanıt çağırana olduğu gibi döner (gövde kopyadan okunur).
const KILIT_KODU = "uyelik_suresi_doldu";
const YENILE_YOLU = "/yenile";

export function uyelikKilidiYakalayiciKur() {
  if (typeof window === "undefined" || typeof window.fetch !== "function" || window.__uyelikKilidiYakalayici) return;
  window.__uyelikKilidiYakalayici = true;
  const asilFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const yanit = await asilFetch(...args);
    if (yanit.status === 403 && !window.location.pathname.startsWith(YENILE_YOLU)) {
      try {
        const govde = await yanit.clone().json();
        if (govde && govde.m === KILIT_KODU) window.location.assign(YENILE_YOLU);
      } catch (_) {
        // JSON olmayan 403: dokunma
      }
    }
    return yanit;
  };
}
